import { render, staticRenderFns } from "./DashboardPowerBI.vue?vue&type=template&id=66529460&scoped=true"
import script from "./DashboardPowerBI.vue?vue&type=script&lang=js"
export * from "./DashboardPowerBI.vue?vue&type=script&lang=js"
import style0 from "./DashboardPowerBI.vue?vue&type=style&index=0&id=66529460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66529460",
  null
  
)

export default component.exports